module.exports = __webpack_public_path__ + "assets/images/hotel-04.7cb838497cc668b6dd5063cf36cec3d4.svg";